import { Api } from "./Api";
import axios from "axios";
import { RelanceTemplate } from "../models/RelanceTemplate";

export class RelanceTemplateApi extends Api {
    constructor() {
        super("relance-v3/templates");
    }

    getAll(): Promise<RelanceTemplate.Collection> {
        return axios.get(this.apiUrl.replace(/\/$/, "")).then(function (
            response
        ) {
            let data = response.data || {};
            return <RelanceTemplate.Collection>{
                levels: data.levels || {},
                templates: data.templates || {},
            };
        });
    }

    save(
        level: number,
        template: RelanceTemplate
    ): Promise<RelanceTemplate> {
        return axios
            .put(this.apiUrl + level, template)
            .then(function (response) {
                return <RelanceTemplate>(response.data || template);
            });
    }

    reset(level: number): Promise<RelanceTemplate> {
        return axios.delete(this.apiUrl + level).then(function (response) {
            return <RelanceTemplate>response.data;
        });
    }
}
